<template>
	<div class="questionMessageRecord">
		<van-notice-bar mode="closeable" background="#333333" color="#ffffff">{{
			baseInfo.title
		}}</van-notice-bar>
		<div class="questionMessageRecord_topic">
			<div class="questionMessageRecord_topic_word">
				<div
					class="questionMessageRecord_title"
					style="text-indent:0;margin-bottom:8px;"
				>
					正文：
				</div>
				{{ baseInfo.context }}
				<br />
				<br />
				<div class="questionMessageRecord_topic_attachment">
					附件下载：<a
						:href="item.url"
						v-for="(item, index) in computedParseName(
							baseInfo.attachmentAddress
						)"
						:key="index"
						>{{ item.name }}</a
					>
				</div>
				<br />
				<br />
				<div
					class="questionMessageRecord_title"
					style="text-indent:0;margin-bottom:8px;"
				>
					历史消息：
				</div>
				<div
					class="questionMessageRecord_content_item"
					v-for="(item, index) in baseInfo.message"
					:key="index"
				>
					<div class="questionMessageRecord_content_item_title">
						{{ item.staffNo }} - {{ item.createTimeStr }} ：
					</div>
					<div class="questionMessageRecord_content_item_word">
						{{ item.context }}
					</div>
				</div>
			</div>
		</div>
		<div class="questionMessageRecord_title">我的回复：</div>
		<div class="questionMessageRecord_reply">
			<div class="questionMessageRecord_reply_word">
				<van-field
					v-model="content"
					placeholder="请填写您补充的消息说明"
					rows="5"
					autosize
					type="textarea"
				/>
			</div>
		</div>
		<div class="questionMessageRecord_btns">
			<div class="questionMessageRecord_btns_cancel" @click="handleBack">
				取消
			</div>
			<div
				class="questionMessageRecord_btns_confirm"
				@click="() => handleReply()"
			>
				提交
			</div>
		</div>
	</div>
</template>

<script>
import { parseName } from "@/app/utils";
import { NoticeBar, Field, Toast } from "vant";
export default {
	computed: {
		computedParseName() {
			return function(value) {
				return parseName(value);
			};
		}
	},
	components: {
		[NoticeBar.name]: NoticeBar,
		[Field.name]: Field
	},
	data() {
		return {
			content: "",
			baseInfo: {}
		};
	},
	mounted() {
		this.fetchData();
	},
	methods: {
		handleBack() {
			window.history.back(-1);
		},
		async fetchData() {
			let { id } = this.$route.query;
			let data = await this.h5Ajax(
				"get",
				`$/inbox/getInboxAndReply`,
				{ id },
				true
			);
			let current = data.shift();
			this.baseInfo = { ...current, message: data };
			console.log(this.baseInfo);
		},
		async handleReply() {
			let content = this.content;
			let { id } = this.$route.query;
			if (content) {
				let { code } = await this.h5Ajax(
					"post",
					"$/inbox/replyMsg",
					{
						id,
						context: content
					},
					true,
					true
				);
				if (code === 200) {
					Toast({
						message: "提交成功",
						forbidClick: true,
						onClose: () => {
							this.$router.push({
								path: "/question/message"
							});
						}
					});
				}
			} else {
				Toast("请输入内容");
			}
		}
	}
};
</script>

<style>
@import "./index.css";
</style>



// WEBPACK FOOTER //
// src/app/pages/question/message/record/index.vue